module.exports = "/cyber/_next/static/images/mts-logo-cf7ee7f80a743bc17e80795270cff0ff.png";